import withReducer from '../../store/withReducer'
import QtEkgReview from './container'
import reducer from './module'

export default withReducer('qtEkgReview', reducer)(QtEkgReview)



// WEBPACK FOOTER //
// ./src/legacy/pages/QtEkgReview/index.js